module.exports = __webpack_public_path__ + "img/hanging-open.e9e2e516.png";